// src/pages/OAuthBridge.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setTokens } from '../utils';
import { jwtDecode } from 'jwt-decode';
import { fetchUserType } from '../utils';

export default function OAuthBridge({ setIsLoggedIn, setUsername }) {
  const navigate = useNavigate();

  useEffect(() => {
    const hashOrQuery = window.location.hash?.slice(1) || window.location.search?.slice(1) || '';
    const params = new URLSearchParams(hashOrQuery);
    const access = params.get('access');
    const refresh = params.get('refresh');
    const emailFromParam = params.get('email'); // backend küldi

    if (!access || !refresh) {
      navigate('/login', { replace: true });
      return;
    }

    setTokens(access, refresh);

    // username beállítása (paramból vagy tokenből)
    try {
      const decoded = jwtDecode(access);
      const emailFromToken = decoded?.email;
      const email = emailFromParam || emailFromToken;
      if (email && setUsername) {
        setUsername(email);
        localStorage.setItem('username', email);
      }
      if (decoded?.user_id) {
        localStorage.setItem('user_id', decoded.user_id);
      }
    } catch {}

    (async () => {
      const uType = await fetchUserType(access);
      if (setIsLoggedIn) setIsLoggedIn(true);
      const target = uType === 'provider' ? '/AppointmentsTrai/Appointments' : '/services';
      navigate(target, { replace: true });
    })();
  }, [navigate, setIsLoggedIn, setUsername]);

  return <div>Signing you in…</div>;
}
